export function isCanada() {
    //return true for local app
    // return true;
    return window.location.href.includes('.ca') || window.location.href.includes('ford.ca')
}

export function getLanguage() {
    //return 'fr' for local app
    // return 'fr';
    return window.location.href.includes('.ca') || window.location.href.includes('ford.ca') ? 'fr' : 'en'
}
